// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"b3689a9a","184":"2fcf08d9","196":"fce0e7d7","405":"a128de3c","453":"0593f689","487":"15882e81","561":"e84e9900","622":"f709c156","665":"b97152c3","668":"c64c3cb7","740":"ca39978c","788":"d3121411","793":"3c7f9202","832":"17fe6a1b","839":"23053060","956":"37ccc5cf"}[chunkId] + ".chunk.js";
};